import React from 'react'
import { SmlsButton, SmlsModal } from "@smiles/smiles-ui-kit-react";
import { ModalBody } from "reactstrap";
import { useTranslation } from 'react-i18next';
import HyperLink from '../Hyperlink';
import { useAccountUnderReviewModal } from '../../context/AccountUnderReviewModalContext';
import { getLink } from '../../utils';

export function AccountUnderReviewModal() {
  const { accountUnderReviewModal } = useAccountUnderReviewModal()
  const { t } = useTranslation("modal_account_under_review")

  function handleButtonClick() {
    const promoUrl = getLink('promocao')
    window.location.href = promoUrl
  }

  function handleHyperlinkClick() {
    const homeUrl = getLink('home')
    window.location.href = homeUrl
  }

  return (
    <SmlsModal
      isOpen={accountUnderReviewModal.isModalOpen}
      type='right'
      toggle={accountUnderReviewModal.toggleModal}
      onExit={accountUnderReviewModal.closeModal}
    >
      <ModalBody className="smls-modal-body account-under-review-container">
        <div className="smls-modal-header">
          <h4>{t('title')}</h4>
        </div>

        <div className="smls-modal-text">
          <p>{t('description')}</p>
        </div>

        <SmlsButton
          text={t('button')}
          className='account-under-review-button'
          onClick={handleButtonClick}
        />

        <HyperLink
          text={t('hyperlink')}
          className='hyperlink-with-underline mt-4 account-under-review-hyperlink'
          onClick={handleHyperlinkClick} 
        />
      </ModalBody>
    </SmlsModal>
  )
}

